import { onMessageFromWebApp } from "./webAppMessenger";
import { QR_START_SCANNING, QR_STOP_SCANNING } from "./messageTypes";

const screenOrientation = window.screen && window.screen.orientation;

if (screenOrientation) {
  if (screenOrientation.lock) {
    onMessageFromWebApp(QR_START_SCANNING, () => {
      screenOrientation.lock("portrait");
    });
  }

  if (screenOrientation.unlock) {
    onMessageFromWebApp(QR_STOP_SCANNING, () => {
      screenOrientation.unlock("portrait");
    });
  }
}
